export default __webpack_public_path__ + "static/media/hero-bcg-22.a7a8f357.jpg";